import { Stack } from '@mui/material';
import { GridPagination, gridRowCountSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';
import { NextPaginationButton, PreviousPaginationButton } from '.';

const TablePagination = () => {
  const apiRef = useGridApiContext();
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  return (
    <Stack direction="row" alignItems="center">
      <GridPagination
        count={rowCount ?? 0}
        // Hide 'Go to next page' and 'Go to previous page' tooltips
        getItemAriaLabel={() => ''}
        slots={{
          actions: {
            previousButton: PreviousPaginationButton,
            nextButton: NextPaginationButton,
          },
        }}
      />
    </Stack>
  );
};
export default TablePagination;
